import { Component } from '@angular/core';
import { AuthService } from '../../core/auth';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
    constructor(private authService: AuthService) {}

    get fullName(): string {
        return this.authService.getUserProfile().name;
    }

    get nameInitials(): string {
        return this.fullName
            .split(' ')
            .map((part) => part.charAt(0))
            .join('');
    }

    public logout() {
        this.authService.signOut();
    }
}
